import type { App } from 'vue'
import { STORAGE_SERVICE_KEY } from '@/domain/interfaces/IStorageService'
import { LocalStorageService } from '@/infrastructure/storage/local-storage.service'
import { USER_PROFILE_SERVICE_KEY } from '@/domain/interfaces/IUserProfileService'
import { UserProfileService } from '@/features/user/services/user-profile.service'
import { COMPANY_DETAIL_SERVICE_KEY } from '@/domain/interfaces/ICompanyDetailService'
import { CompanyDetailService } from '@/features/companydetail/services/company-detail.service'

export function setupProviders(app: App): void {
  app.provide(STORAGE_SERVICE_KEY, new LocalStorageService())
  app.provide(USER_PROFILE_SERVICE_KEY, new UserProfileService())
  app.provide(COMPANY_DETAIL_SERVICE_KEY, new CompanyDetailService())
}
